import { useEffect, useState } from "react";
import { pocketbase } from "../services/pocketbase";
import { AuthContext } from "../context/auth";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { DiscIcon as Discord, Loader2 } from "lucide-react"
import { PlayerProfile } from "@/multiplayer";

function LoginComponent() {
	const [loading, setLoading] = useState(false)

	// Array of auth providers that you can easily edit
	const authProviders = [{ id: "discord", name: "Discord", icon: Discord }]

	const handleProviderAuth = async (providerId: string) => {
		setLoading(true);

		try {
			// Redirect to the provider's auth page
			const authData = await pocketbase().collection('users').authWithOAuth2({
				provider: providerId
			});
			console.log('Logged in with provider:', authData);
		} catch (err) {
			toast.error('Error logging in with provider', {
				description: `${(err as Error).message}`,
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="flex items-center justify-center min-h-[400px] w-full max-w-md mx-auto">
			<Card className="w-full min-h-[300px]">
				<CardHeader className="space-y-1">
					<CardTitle className="text-2xl font-bold text-center">Welcome to Card Engine</CardTitle>
					<CardDescription className="text-center">Sign in to your account to continue</CardDescription>
				</CardHeader>
				<CardContent className="flex flex-1 items-center">
					<div className="grid gap-4 w-full">
						{authProviders.map((provider) => (
							<Button
								key={provider.id}
								onClick={() => handleProviderAuth(provider.id)}
								disabled={loading}
								size="lg"
								className="w-full"
								variant="outline"
							>
								{loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <provider.icon className="mr-2 h-4 w-4" />}
								Sign in with {provider.name}
							</Button>
						))}
					</div>
				</CardContent>
				<CardFooter className="flex flex-col">
					{/* <div className="text-sm text-muted-foreground text-center mt-2">
						By signing in, you agree to our Terms of Service and Privacy Policy
					</div> */}
				</CardFooter>
			</Card>
		</div>
	)
}

export type AuthRecord = {
	avatar?: string
	collectionId: string
	collectionName: string
	created: string
	email: string
	emailVisibility: boolean
	id: string
	name: string
	updated: string
	verified: boolean
}


export function AuthGuardProvider({ children }: { children: React.ReactNode }) {
	const [loggedIn, setLoggedIn] = useState(false);
	const [playerProfile, setPlayerProfile] = useState<PlayerProfile | undefined>(undefined);


	useEffect(() => {
		{
			const isValid = pocketbase().authStore.isValid;
			const record = pocketbase().authStore.record as AuthRecord;

			if (isValid && record) { // TODO: it appears this check doesn't work for some reason...
				setLoggedIn(true);
				setPlayerProfile({
					id: record.id,
					name: record.name,
					avatar: record.avatar,
				});
			} else {
				setLoggedIn(false);
				setPlayerProfile(undefined)
			}
		}


		return pocketbase().authStore.onChange((token, record) => {
			if (token && record) {
				setLoggedIn(true);
				setPlayerProfile({
					id: record.id,
					name: record.name,
					avatar: record.avatar,
				});
			} else {
				setLoggedIn(false);
				setPlayerProfile(undefined);
			}
		})
	}, []);

	return (
		<AuthContext.Provider value={{ loggedIn, playerProfile: playerProfile! }}>
			{!loggedIn ? (
				<div className="flex items-center justify-center h-screen">
					<LoginComponent />
				</div>
			) : children}
		</AuthContext.Provider>
	);
}